import Vue from 'vue';
import App from './App';
import api from './utils/api';
import store from './store';
import router from './router';
import './assets/styles/base/global.css';
import './assets/styles/modules/img.css';
import './assets/styles/util/helper.css';

// mixins & plugins
import fileOperation from './plugins/fileOperation';
import './utils/helper';

Vue.prototype.$api = api;
Vue.prototype.$fileOperation = fileOperation;
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  async beforeCreate() {
    // 放入 API 實體到 store
    await this.$store.dispatch('setApiToStore', this.$api);
  },
});
